import { CommonModule, NgSwitch } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { FacetUrlModule } from '@df/module-facet-url/facet-url.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { SwatchComponent } from '../../../catalog/attribute/swatch/swatch.component';
import { Product } from '../../../catalog/product/product.decorator';
import { FilterExpandableComponent } from './filter-expandable.component';
@Component({
    selector: 'filter-attribute-option',
    templateUrl: './filter-attribute-option.html',
    styleUrls: ['./filter-attribute-option.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [GridModule, CommonModule, FilterExpandableComponent, TranslationModule, SwatchComponent, FacetUrlModule, HrefComponent, NgSwitch]
})
export class FilterAttributeOptionComponent<T extends Product> extends FilterAttributeOptionComponentDef<T> {
    zippyId() {
        return ['filter', this.filter.id];
    }
    @Input()
    isDefault = false;
}
